
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/connect-tools",
      function () {
        return require("private-next-pages/info/connect-tools/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/connect-tools"])
      });
    }
  